module.exports = __webpack_public_path__ + "packs/media/images/das_matching_3-995918ef0bae0f7ae39319e2dfeb9b47.jpg";